module.exports = {
  Color: {
    CorePurple100: "#F1EBFF",
    CorePurple200: "#DBCCFF",
    CorePurple300: "#CBB2FF",
    CorePurple400: "#B796FF",
    CorePurple500: "#AA85FF",
    CorePurple600: "#8652FF",
    CorePurple700: "#631FFF",
    CorePurple800: "#4700EB",
    CorePurple900: "#290087",
    CoreRed100: "#FFEBF0",
    CoreRed200: "#FFD2DC",
    CoreRed300: "#FEB9CB",
    CoreRed400: "#FDA0B8",
    CoreRed500: "#FD87A6",
    CoreRed600: "#FC5A85",
    CoreRed700: "#FB3268",
    CoreRed800: "#EB0744",
    CoreRed900: "#C80438",
    CoreOrange100: "#FFE6D6",
    CoreOrange200: "#FFC5A0",
    CoreOrange300: "#FFB487",
    CoreOrange400: "#FFA26F",
    CoreOrange500: "#FE9058",
    CoreOrange600: "#FC7D41",
    CoreOrange700: "#F9682A",
    CoreOrange800: "#DD5024",
    CoreOrange900: "#C2451E",
    CoreYellow100: "#FFF7DE",
    CoreYellow200: "#FFECB6",
    CoreYellow300: "#FFE49C",
    CoreYellow400: "#FFDC81",
    CoreYellow500: "#FFD465",
    CoreYellow600: "#FFCC47",
    CoreYellow700: "#FFC31F",
    CoreYellow800: "#EBAC00",
    CoreYellow900: "#D69D00",
    CoreGreen100: "#E4F6EB",
    CoreGreen200: "#C0EBD0",
    CoreGreen300: "#A7E3BD",
    CoreGreen400: "#8FDBAB",
    CoreGreen500: "#76D397",
    CoreGreen600: "#5BCA84",
    CoreGreen700: "#3BC170",
    CoreGreen800: "#35A260",
    CoreGreen900: "#2B7A4B",
    CoreTeal100: "#D1F3F7",
    CoreTeal200: "#BAEDF2",
    CoreTeal300: "#ABE8EF",
    CoreTeal400: "#92E2EA",
    CoreTeal500: "#81DDE7",
    CoreTeal600: "#62D7E3",
    CoreTeal700: "#33CADB",
    CoreTeal800: "#2CBCC9",
    CoreTeal900: "#30828B",
    CoreBlue100: "#DDEBFF",
    CoreBlue200: "#B5D1FF",
    CoreBlue300: "#9BC0FF",
    CoreBlue400: "#81AEFF",
    CoreBlue500: "#679DFF",
    CoreBlue600: "#4A8BFD",
    CoreBlue700: "#2379FA",
    CoreBlue800: "#055FE6",
    CoreBlue900: "#033682",
    CoreSlate50: "#F4F4F6",
    CoreSlate100: "#E6E6EA",
    CoreSlate200: "#D7D8DF",
    CoreSlate300: "#C9CAD3",
    CoreSlate400: "#BBBCC8",
    CoreSlate500: "#ADAEBC",
    CoreSlate600: "#9FA1B1",
    CoreSlate700: "#9194A6",
    CoreSlate800: "#6A6D81",
    CoreSlate900: "#3C3E49",
    CoreSlate1000: "#0E0E11",
    PrimaryBlack: "#000000",
    PrimaryWhite: "#FFFFFF",
    PrimaryPurple: "#631FFF",
    PrimaryRed: "#FB3268",
    PrimaryOrange: "#F9682A",
    PrimaryYellow: "#FFC31F",
    PrimaryGreen: "#3BC170",
    PrimaryTeal: "#33CADB",
    PrimaryBlue: "#2379FA",
    BackgroundPrimary: "#FFFFFF",
    BackgroundSecondary: "#F4F4F6",
    BackgroundButtonDefault: "#E6E6EA",
    BackgroundButtonDefaultActive: "#C9CAD3",
    BackgroundButtonDefaultDisabled: "#E6E6EA",
    BackgroundButtonText: "#FFFFFF",
    BackgroundButtonTextActive: "#F1EBFF",
    BackgroundButtonTextDisabled: "#F4F4F6",
    BackgroundButtonPrimary: "#631FFF",
    BackgroundButtonPrimaryActive: "#290087",
    BackgroundButtonPrimaryDisabled: "#B796FF",
    BackgroundButtonDanger: "#EB0744",
    BackgroundButtonDangerActive: "#C80438",
    BackgroundButtonDangerDisabled: "#FDA0B8",
    BackgroundInputDefault: "#FFFFFF",
    BackgroundInputDisabled: "#F4F4F6",
    BackgroundInputCheckbox: "#FFFFFF",
    BackgroundInputCheckboxChecked: "#2379FA",
    BackgroundInputCheckboxDisabled: "#C9CAD3",
    BackgroundInputToggle: "#6A6D81",
    BackgroundInputToggleDisabled: "#C9CAD3",
    BackgroundInputToggleChecked: "#631FFF",
    BackgroundInputToggleCheckedDisabled: "#CBB2FF",
    BackgroundInputToggleDanger: "#EB0744",
    BackgroundInputToggleDangerDisabled: "#FDA0B8",
    BackgroundLabelGrey: "#E6E6EA",
    BackgroundLabelGreyHover: "#BBBCC8",
    BackgroundLabelGreyDisabled: "#F4F4F6",
    BackgroundLabelDarkGrey: "#C9CAD3",
    BackgroundLabelDarkGreyHover: "#ADAEBC",
    BackgroundLabelDarkGreyDisabled: "#E6E6EA",
    BackgroundLabelPurple: "#CBB2FF",
    BackgroundLabelPurpleHover: "#AA85FF",
    BackgroundLabelPurpleDisabled: "#F1EBFF",
    BackgroundLabelRed: "#FEB9CB",
    BackgroundLabelRedHover: "#FD87A6",
    BackgroundLabelRedDisabled: "#FFEBF0",
    BackgroundLabelDarkRed: "#EB0744",
    BackgroundLabelDarkRedHover: "#C80438",
    BackgroundLabelDarkRedDisabled: "#FEB9CB",
    BackgroundLabelOrange: "#FFC5A0",
    BackgroundLabelOrangeHover: "#FE9058",
    BackgroundLabelOrangeDisabled: "#FFE6D6",
    BackgroundLabelYellow: "#FFECB6",
    BackgroundLabelYellowHover: "#FFD465",
    BackgroundLabelYellowDisabled: "#FFF7DE",
    BackgroundLabelGreen: "#A7E3BD",
    BackgroundLabelGreenHover: "#76D397",
    BackgroundLabelGreenDisabled: "#E4F6EB",
    BackgroundLabelTeal: "#ABE8EF",
    BackgroundLabelTealHover: "#81DDE7",
    BackgroundLabelTealDisabled: "#D1F3F7",
    BackgroundLabelBlue: "#9BC0FF",
    BackgroundLabelBlueHover: "#679DFF",
    BackgroundLabelBlueDisabled: "#DDEBFF",
    BackgroundLabelWhite: "#FFFFFF",
    BackgroundLabelWhiteHover: "#C9CAD3",
    BackgroundLabelWhiteDisabled: "#FFFFFF",
    BackgroundDocsNoteDefault: "#FFF7DE",
    BackgroundDocsNoteFeedback: "#DDEBFF",
    BackgroundDocsNoteActionItem: "#FFEBF0",
    BackgroundDocsNoteFlow: "#F1EBFF",
    BackgroundDocsFrameLabelSlate: "#0E0E11",
    BackgroundDocsFrameLabelPurple: "#631FFF",
    BackgroundDocsFrameLabelBlue: "#2379FA",
    BackgroundDocsFrameLabelRed: "#FB3268",
    TextPrimary: "#0E0E11",
    TextSecondary: "#6A6D81",
    TextInverse: "#FFFFFF",
    TextActive: "#631FFF",
    TextDanger: "#EB0744",
    TextDisabled: "#6A6D81",
    BorderHairline: "#E6E6EA",
    BorderDivider: "#D7D8DF",
    BorderIconPrimary: "#0E0E11",
    BorderIconSecondary: "#6A6D81",
    BorderIconInverse: "#FFFFFF",
    BorderIconActive: "#631FFF",
    BorderIconSuccess: "#35A260",
    BorderIconWarning: "#EBAC00",
    BorderIconDanger: "#EB0744",
    BorderIconDisabled: "#ADAEBC",
    BorderIconLabelGrey: "#6A6D81",
    BorderIconLabelGreyDisabled: "#E6E6EA",
    BorderIconLabelDarkGrey: "#3C3E49",
    BorderIconLabelDarkGreyDisabled: "#D7D8DF",
    BorderIconLabelPurple: "#290087",
    BorderIconLabelPurpleDisabled: "#DBCCFF",
    BorderIconLabelRed: "#C80438",
    BorderIconLabelRedDisabled: "#FFD2DC",
    BorderIconLabelDarkRed: "#FFFFFF",
    BorderIconLabelDarkRedDisabled: "#FFFFFF",
    BorderIconLabelOrange: "#C2451E",
    BorderIconLabelOrangeDisabled: "#FFC5A0",
    BorderIconLabelYellow: "#D69D00",
    BorderIconLabelYellowDisabled: "#FFE49C",
    BorderIconLabelGreen: "#2B7A4B",
    BorderIconLabelGreenDisabled: "#C0EBD0",
    BorderIconLabelTeal: "#30828B",
    BorderIconLabelTealDisabled: "#ABE8EF",
    BorderIconLabelBlue: "#033682",
    BorderIconLabelBlueDisabled: "#B5D1FF",
    BorderIconLabelWhite: "#9194A6",
    BorderIconLabelWhiteDisabled: "#E6E6EA",
    BorderInputDefault: "#6A6D81",
    BorderInputActive: "#631FFF",
    BorderInputDanger: "#EB0744",
    BorderInputDisabled: "#6A6D81",
    BorderNoteDefault: "#FFCC47",
    BorderNoteFeedback: "#4A8BFD",
    BorderNoteActionItem: "#FC5A85",
    BorderNoteFlow: "#8652FF",
  },
};
